import { LuminousGallery } from 'luminous-lightbox'

window.onload = () => {
    let imgsEl = document.querySelectorAll('#content a[href] img, .content a[href] img'),
        GalleryEl = [],
        hrefImgRegex = new RegExp('(jpg|gif|png|jpeg)$')

    for (const imgEl of imgsEl) {
        let linkEl = imgEl.parentNode.closest('a')

        if (hrefImgRegex.test(linkEl.getAttribute('href'))) {
            GalleryEl.push(linkEl)
        }
    }

    if (GalleryEl.length > 0) {
        const lboxGallery = new LuminousGallery(
            GalleryEl,
            {
                arrowNavigation: true,
            },
            {
                showCloseButton: true,
            }
        )
    }
}
